export default __webpack_public_path__ + "static/media/cathodic-protection.f3c30540.jpg";